<template>
	<v-app>
		<!--
		<loading :loading="loading" />
		-->
		<div v-if="!isMobile()">
			<v-dialog v-model="dialogPesquisa" width="600">
				<v-card>
					<v-toolbar class="text-center" color="green" dark>Tipos de Pesquisa</v-toolbar>
					<v-card-text>
						<div class="text-body-2 text-left pt-4">Todas as observações - digitar 'todos' no campo de pesquisa</div>
						<div class="text-body-2 text-left pt-4">Por UF - digitar 'rj' no campo de pesquisa por exemplo</div>
						<div class="text-body-2 text-left pt-4">Por tipo de solo - digitar 'argissolo' no campo de pesquisa por exemplo</div>
					</v-card-text>
					<v-card-actions class="justify-end">
						<v-btn text @click="dialogPesquisa = false">OK</v-btn>
					</v-card-actions>
				</v-card>
			</v-dialog>
			<v-dialog v-model="dialogLoading" persistent fullscreen content-class="loading-dialog">
				<v-container fill-height>
					<v-layout class="row justify-center align-center flex-column">
						<h1 class="color-loading">Aguarde...</h1>
						<v-progress-circular indeterminate :size="70" :width="7" color="green"></v-progress-circular>
					</v-layout>
				</v-container>
			</v-dialog>
			<v-dialog v-model="dialogAbout" width="600">
				<v-card>
					<v-toolbar class="text-center" color="green" dark>Sobre</v-toolbar>
					<v-card-text>
						<div class="text-subtitle-1 text-left pt-4">Desenvolvedor:</div>
						<div class="text-body-2 text-left">Filippo Maio</div>
						<div class="text-subtitle-1 text-left pt-4">Orientador:</div>
						<div class="text-body-2 text-left">Sérgio Serra</div>
						<div class="text-subtitle-1 text-left pt-4">Coorientador:</div>
						<div class="text-body-2 text-left">Gabriel Compto</div>
					</v-card-text>
					<v-card-actions class="justify-end">
						<v-btn text @click="dialogAbout = false">OK</v-btn>
					</v-card-actions>
				</v-card>
			</v-dialog>
			<v-app-bar id="app-bar" absolute app color="transparent" flat height="20"></v-app-bar>
			<v-navigation-drawer id="core-navigation-drawer" dark app left width="260" src="../assets/sidebar.jpg">
				<template v-slot:img="props">
					<v-img :gradient="`to bottom, rgba(35, 20, 10, .9), rgba(35, 20, 10, .9)`" v-bind="props" />
				</template>
				<v-divider class="mb-1" />
				<v-list dense nav>
					<v-list-item>
						<v-list-item-avatar class="ml-13" rounded height="120" width="120">
							<v-img src="../assets/logoVR.png" max-height="300" />
						</v-list-item-avatar>
					</v-list-item>
				</v-list>
				<v-divider class="mb-2" />
				<v-list expand nav class="ma-3">
					<div />
					<v-list-item href="#" rel="noopener" target="undefined" to="/" active-class="">
						<v-list-item-icon>
							<v-icon>mdi-map-marker</v-icon>
						</v-list-item-icon>
						<v-list-item-content>
							<v-list-item-title class="text-left">Mapa</v-list-item-title>
						</v-list-item-content>
					</v-list-item>
					<v-list-item href="#" rel="noopener" target="undefined" to="/admin" active-class="">
						<v-list-item-icon>
							<v-icon>mdi-cloud-upload</v-icon>
						</v-list-item-icon>
						<v-list-item-content>
							<v-list-item-title class="text-left">Upload de Imagem</v-list-item-title>
						</v-list-item-content>
					</v-list-item>
					<div />
				</v-list>
				<template v-slot:append>
					<v-list-item>
						<v-list-item-content>
							<v-row>
								<v-col>
									<v-btn height="70px" href="https://r1.ufrrj.br/petsi/" target="_blank" text><img src="../assets/logo-pet.png" width="70px"/></v-btn>
									<v-btn height="70px" href="https://portal.ufrrj.br/" target="_blank" text><img src="../assets/logo-rural.png" width="70px"/></v-btn>
								</v-col>
							</v-row>
							<v-row>
								<v-col>
									<v-btn height="40px" text @click="dialogAbout = true"><img src="../assets/easteregg.png" width="40px"/></v-btn>
								</v-col>
							</v-row>
						</v-list-item-content>
					</v-list-item>
				</template>
			</v-navigation-drawer>
			<v-content fluid>
				<v-container>
					<v-card class="px-5 py-3">
						<v-sheet class="pa-4 text-center mt-n6" color="green" elevation="6" dark>
							<div class="display-1">Mapa</div>
						</v-sheet>
						<v-card-text class="px-0 pb-0" relative>
							<div>
								<GmapMap
									:center="center"
									:zoom="5"
									map-type-id="roadmap"
									:style="getTamanhoMapa"
									:options="{
										zoomControl: true,
										mapTypeControl: false,
										scaleControl: false,
										streetViewControl: false,
										rotateControl: false,
										fullscreenControl: false,
										disableDefaultUi: false,
									}"
								>
									<GmapMarker :key="index" v-for="(m, index) in markers" :icon="getIcon(m)" :position="{ lat: parseFloat(m.latitude), lng: parseFloat(m.longitude) }" :clickable="m.clicavel" :draggable="false" @click="$router.push('VR?id=' + m.id + '')" />
								</GmapMap>
							</div>
							<div :style="getPosicaoPesquisar">
								<v-row>
									<v-btn class="mt-2" icon @click="dialogPesquisa = true"><v-icon>mdi-help-circle</v-icon></v-btn>
									<v-text-field solo label="Pesquisar" v-model="consulta" append-icon="mdi-magnify" @click:append="getCenariosFilter"></v-text-field>
								</v-row>
							</div>
						</v-card-text>
					</v-card>
				</v-container>
			</v-content>
			<!--v-footer padless>
				<v-col class="text-center" cols="12"> {{ new Date().getFullYear() }} — <strong>Filippo Maio</strong> </v-col>
			</v-footer-->
		</div>
		<div v-else>
			<v-app-bar dark color="#362E14">
				<v-app-bar-title>
					OpenSoils VR
				</v-app-bar-title>
				<v-spacer></v-spacer>
				<v-btn color="#324413" href="#" rel="noopener" target="undefined" to="/admin">Upload de Imagem</v-btn>
			</v-app-bar>
			<v-toolbar dense>
				<v-text-field ref="inputText" autofocus="autofocus" hide-details single-line label="Pesquisar" v-model="consulta" append-icon="mdi-magnify" @click:append="getCenariosFilter"></v-text-field>
			</v-toolbar>
			<GmapMap
				:center="center"
				:zoom="4"
				map-type-id="roadmap"
				:style="getTamanhoMapaMobile"
				:options="{
					zoomControl: true,
					mapTypeControl: false,
					scaleControl: false,
					streetViewControl: false,
					rotateControl: false,
					fullscreenControl: false,
					disableDefaultUi: false,
				}"
			>
				<GmapMarker :key="index" v-for="(m, index) in markers" :icon="getIcon(m)" :position="{ lat: parseFloat(m.latitude), lng: parseFloat(m.longitude) }" :clickable="m.clicavel" :draggable="false" @click="$router.push('VR?id=' + m.id + '')" />
			</GmapMap>
		</div>
	</v-app>
</template>

<script>
import { mapActions, mapState } from "vuex";
import UF from "../assets/estados_brasil_area.json";
import FiltrarPorEstado from "robust-point-in-polygon";
//import loading from "../components/loading.vue";

export default {
	name: "Home",
	data() {
		return {
			center: { lat: -13.43, lng: -53.98 },
			markers: [],
			consulta: "",
			hostDB: "mysql",
			loading: false,
			dialogPesquisa: false,
			dialogLoading: false,
			dialogAbout: false,
		};
	},
	//components: {loading},
	async created() {},
	async mounted() {
		await this.getCenarios();
		await this.getCenariosVR();
	},
	methods: {
		...mapActions(["getCenarios"]),
		...mapActions(["getCenariosBySolo"]),
		...mapActions(["getCenariosVR"]),

		async getCenariosFilter() {
			this.dialogLoading = true;
			if (this.isMobile()) {
				this.$refs.inputText.blur();
			}
			this.markers = [];
			let poligonoEstado = [];
			this.consulta = this.consulta.toLowerCase();
			if (this.consulta == "todos") {
				for (let i = 0; i < this.cenarios.length; i++) {
					let clicavel = false;
					for (let j = 0; j < this.cenariosVR.length; j++) {
						if (!clicavel && this.cenarios[i].id_observacao == this.cenariosVR[j].idOpenSoilsBD) {
							clicavel = true;
						}
					}
					if(clicavel || !this.isMobile()){
						this.markers.push({ latitude: parseFloat(this.cenarios[i].latitude), longitude: parseFloat(this.cenarios[i].longitude), id: this.cenarios[i].id_observacao, clicavel: clicavel });
					}
				}
			} else {
				if (this.hostDB == "firebase") {
					for (let i = 0; i < this.cenarios.length; i++) {
						if (this.cenarios[i].info.indexOf(this.consulta) > 0) {
							this.markers.push(this.cenarios[i]);
						}
					}
				} else {
					if (this.markers.length == 0) {
						for (let i = 0; i < UF.length; i++) {
							if (this.consulta == UF[i].sigla.toLowerCase() || this.consulta == UF[i].nome.toLowerCase()) {
								for (let j = 0; j < UF[i].area.length; j++) {
									poligonoEstado.push([UF[i].area[j][1], UF[i].area[j][0]]);
								}
							}
						}
						if (poligonoEstado.length > 0) {
							let ponto = [];
							let classificacao = 0;
							for (let i = 0; i < this.cenarios.length; i++) {
								ponto = [parseFloat(this.cenarios[i].latitude), parseFloat(this.cenarios[i].longitude)];
								classificacao = FiltrarPorEstado(poligonoEstado, ponto);
								if (classificacao != 1) {
									// -1 dentro , 0 borda , 1 fora
									let clicavel = false;
									for (let j = 0; j < this.cenariosVR.length; j++) {
										if (!clicavel && this.cenarios[i].id_observacao == this.cenariosVR[j].idOpenSoilsBD) {
											clicavel = true;
										}
									}
									if(clicavel || !this.isMobile()){
										this.markers.push({ latitude: parseFloat(this.cenarios[i].latitude), longitude: parseFloat(this.cenarios[i].longitude), id: this.cenarios[i].id_observacao, clicavel: clicavel });
									}
								}
							}
						} else {
							await this.getCenariosBySolo(this.consulta);
							for (let i = 0; i < this.cenarios.length; i++) {
								let clicavel = false;
								for (let j = 0; j < this.cenariosVR.length; j++) {
									if (!clicavel && this.cenarios[i].id_observacao == this.cenariosVR[j].idOpenSoilsBD) {
										clicavel = true;
									}
								}
								if(clicavel || !this.isMobile()){
									this.markers.push({ latitude: parseFloat(this.cenarios[i].latitude), longitude: parseFloat(this.cenarios[i].longitude), id: this.cenarios[i].id_observacao, clicavel: clicavel });
								}
							}
						}
					}
				}
			}
			this.loading = true;
		},
		isMobile() {
			if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
				return true;
			} else {
				return false;
			}
		},
		getIcon(cenario) {
			for (let i = 0; i < this.cenariosVR.length; i++) {
				if (cenario.id == this.cenariosVR[i].idOpenSoilsBD) {
					return "https://maps.google.com/mapfiles/ms/icons/blue-dot.png";
				}
			}
			return "https://maps.google.com/mapfiles/ms/icons/red-dot.png";
		},
	},
	computed: {
		...mapState(["cenarios"]),
		...mapState(["cenariosVR"]),

		getTamanhoMapa() {
			return "width: 100%; height: " + (screen.height - 250) + "px";
		},
		getTamanhoMapaMobile() {
			return "width: 100%; height: 95vh"; // + (screen.height * 3) / 4 + "px";
		},
		getPosicaoPesquisar() {
			switch (this.$vuetify.breakpoint.name) {
				case "lg":
					return "position: absolute; top: 100px; width: 300px; left:53vw";
				case "xl":
					return "position: absolute; top: 100px; width: 300px; left:65vw";
			}
			return "position: absolute; top: 100px; width: 300px; left:45vw";
		},
	},

	watch: {
		loading(val) {
			if (!val) return;

			setTimeout(() => (this.loading = false), 4000);
			setTimeout(() => (this.dialogLoading = false), 4000);
		},
	},
};
</script>

<style>
/*html,
body {
	overflow-y: hidden;
}*/

.v-list-item--active {
	color: white;
	background-color: green;
}
.color-loading {
	color: #ffffff;
	stop-opacity: inherit;
}
.loading-dialog {
	background-color: rgba(0, 0, 0, 0.8);
}
td.img-table {
	cursor: pointer;
	user-select: none;
}

.progress {
	font-size: 20px;
	margin-top: -30px;
}
</style>
